import { useComponentModal } from '@/share/components';
import MgUDictCateForm from './mg-u-dict-cate-form';
import MgUDictItemForm from './mg-u-dict-item-form';

export const useUDictEditor = () => {
    const { openEditor } = useComponentModal();

    const showUDictCateEditor = async (title, id) => {
        return openEditor(title, MgUDictCateForm, { id }, {
            fullscreen: false,
            showMaximize: false,
            showMinimize: false,
            width: '40%',
        });
    };

    const showUDictItemEditor = async (title, { id, cate } = {}) => {
        return openEditor(title, MgUDictItemForm, { id, cate }, {
            fullscreen: false,
            showMaximize: false,
            showMinimize: false,
            width: '50%',
        });
    };

    return {
        showUDictCateEditor,
        showUDictItemEditor,
    };
};
